import { IBanner, IHeaderMenu, IOffice } from "../../components/Interfaces";
import bgOutsourcing from "../images/banner/content/bg-outsourcing.png";
import bgAutomation from "../images/banner/content/bg-automation.png";
import bgBlackBox from "../images/banner/content/bg-blackbox.png";
import bgWhiteBox from "../images/banner/content/bg-whitebox.png";
import bgApi from "../images/banner/content/bg-api.png";
import bgPerfomance from "../images/banner/content/bg-perfomance.png";
import bgTestOps from "../images/banner/content/bg-testops.png";
import bgDataservice from "../images/banner/content/bg-dataservice.png";
import bgSSLO from "../images/banner/content/bg-sslo.png";
import bgInfo from "../images/banner/content/bg-info.png";
import bgVision from "../images/banner/content/bg-vision.png";
import bgBenefit from "../images/banner/content/bg-benefit.png";
import bgRecruit from "../images/banner/content/bg-recruit.png";
import bgManagement from "../images/banner/content/bg-management.png";
import bgEthical from "../images/banner/content/bg-ethical.png";
import bgSocial from "../images/banner/content/bg-social.png";
import bgEnviron from "../images/banner/content/bg-environ.png";
import bgBlog from "../images/banner/content/bg-blog.png";
import bgContact from "../images/banner/content/bg-info.png";
import bgAitest from "../images/banner/content/bg-aitest.png";

import tOutsourcing from "../images/banner/content/bg-tablet-outsourcing.png";
import tAutomation from "../images/banner/content/bg-tablet-automation.png";
import tBlackBox from "../images/banner/content/bg-tablet-blackbox.png";
import tWhiteBox from "../images/banner/content/bg-tablet-whitebox.png";
import tApi from "../images/banner/content/bg-tablet-api.png";
import tPerfomance from "../images/banner/content/bg-tablet-perfomance.png";
import tTestOps from "../images/banner/content/bg-tablet-testops.png";
import tDataservice from "../images/banner/content/bg-tablet-dataservice.png";
import tSSLO from "../images/banner/content/bg-tablet-sslo.png";
import tInfo from "../images/banner/content/bg-tablet-info.png";
import tVision from "../images/banner/content/bg-tablet-vision.png";
import tBenefit from "../images/banner/content/bg-tablet-benefit.png";
import tRecruit from "../images/banner/content/bg-tablet-recruit.png";
import tManagement from "../images/banner/content/bg-tablet-management.png";
import tEthical from "../images/banner/content/bg-tablet-ethical.png";
import tSocial from "../images/banner/content/bg-tablet-social.png";
import tEnviron from "../images/banner/content/bg-tablet-environmental.png";
import tBlog from "../images/banner/content/bg-tablet-blog.png";
import tContact from "../images/banner/content/bg-tablet-info.png";
import tAitest from "../images/banner/content/bg-tablet-aitest.png";

import mOutsourcing from "../images/banner/content/bg-mobile-outsourcing.png";
import mAutomation from "../images/banner/content/bg-mobile-automation.png";
import mBlackBox from "../images/banner/content/bg-mobile-blackbox.png";
import mWhiteBox from "../images/banner/content/bg-mobile-whitebox.png";
import mApi from "../images/banner/content/bg-mobile-api.png";
import mPerfomance from "../images/banner/content/bg-mobile-perfomance.png";
import mTestOps from "../images/banner/content/bg-mobile-testops.png";
import mDataservice from "../images/banner/content/bg-mobile-dataservice.png";
import mSSLO from "../images/banner/content/bg-mobile-sslo.png";
import mInfo from "../images/banner/content/bg-mobile-info.png";
import mVision from "../images/banner/content/bg-mobile-vision.png";
import mBenefit from "../images/banner/content/bg-mobile-benefit.png";
import mRecruit from "../images/banner/content/bg-mobile-recruit.png";
import mManagement from "../images/banner/content/bg-mobile-management.png";
import mEthical from "../images/banner/content/bg-mobile-ethical.png";
import mSocial from "../images/banner/content/bg-mobile-social.png";
import mEnviron from "../images/banner/content/bg-mobile-environmental.png";
import mBlog from "../images/banner/content/bg-mobile-blog.png";
import mContact from "../images/banner/content/bg-mobile-info.png";
import mAitest from "../images/banner/content/bg-mobile-aitest.png";

import itemSSLO001 from "../images/content/item/item-sslo-001.png";
import itemSSLO002 from "../images/content/item/item-sslo-002.png";
import itemSSLO003 from "../images/content/item/item-sslo-003.png";
import itemSSLO004 from "../images/content/item/item-sslo-004.png";
import itemSSLO005 from "../images/content/item/item-sslo-005.png";
import itemSSLO006 from "../images/content/item/item-sslo-006.png";
import itemSSLO007 from "../images/content/item/item-sslo-007.png";
import itemSSLO008 from "../images/content/item/item-sslo-008.png";
import itemSSLO009 from "../images/content/item/item-sslo-009.png";
import itemSSLO010 from "../images/content/item/item-sslo-010.png";

import itemHD from "../images/content/item/item-autolabeling-hd.gif";
import itemOD from "../images/content/item/item-autolabeling-od.gif";
import itemIS from "../images/content/item/item-autolabeling-is.gif";
import itemSES from "../images/content/item/item-autolabeling-ses.gif";

import domain01 from "../images/content/item/item-domain-01.png";
import domain02 from "../images/content/item/item-domain-02.png";
import domain03 from "../images/content/item/item-domain-03.png";
import domain04 from "../images/content/item/item-domain-04.png";
import domain05 from "../images/content/item/item-domain-05.png";
import domain06 from "../images/content/item/item-domain-06.png";
import domain07 from "../images/content/item/item-domain-07.png";
import domain08 from "../images/content/item/item-domain-08.png";
import domain09 from "../images/content/item/item-domain-09.png";
import domain10 from "../images/content/item/item-domain-10.png";

import field01 from "../images/content/item/item-service-001.png";
import field02 from "../images/content/item/item-service-002.png";
import field03 from "../images/content/item/item-service-003.png";
import field04 from "../images/content/item/item-service-004.png";
import field05 from "../images/content/item/item-service-005.png";

import build01 from "../images/content/item/item-build-001.png";
import build02 from "../images/content/item/item-build-002.png";
import build03 from "../images/content/item/item-build-003.png";
import build04 from "../images/content/item/item-build-004.png";
import build05 from "../images/content/item/item-build-005.png";
import build06 from "../images/content/item/item-build-006.png";
import build07 from "../images/content/item/item-build-007.png";
import build08 from "../images/content/item/item-build-008.png";
import build09 from "../images/content/item/item-build-009.png";
import build10 from "../images/content/item/item-build-010.png";
import build11 from "../images/content/item/item-build-011.png";
import build12 from "../images/content/item/item-build-012.png";
import build13 from "../images/content/item/item-build-013.png";

import banner01 from "../images/banner/main/banner-main-pc-001.png";
import banner01t from "../images/banner/main/banner-main-tablet-001.png";
import banner01m from "../images/banner/main/banner-main-mobile-001.png";

import ci01 from "../images/cis/pc/01_sk_telecom.png";
import ci02 from "../images/cis/pc/02_logo.png";
import ci03 from "../images/cis/pc/03_lg.png";
import ci04 from "../images/cis/pc/04_lgu+.png";
import ci05 from "../images/cis/pc/05_woongjin.png";
import ci06 from "../images/cis/pc/06_gs.png";
import ci07 from "../images/cis/pc/07_olive_young.png";
import ci08 from "../images/cis/pc/08_kakaopay.png";
import ci09 from "../images/cis/pc/09_tmapmobility.png";
import ci10 from "../images/cis/pc/10_logo.png";
import ci11 from "../images/cis/pc/11_theres.png";
import ci12 from "../images/cis/pc/12_11street.png";
import ci13 from "../images/cis/pc/13_line.png";
import ci14 from "../images/cis/pc/14_kt.png";
import ci15 from "../images/cis/pc/15_tripstore.png";
import ci16 from "../images/cis/pc/16_cyberlogitec.png";
import ci17 from "../images/cis/pc/17_lig.png";
import ci18 from "../images/cis/pc/18_hmm.png";
import ci19 from "../images/cis/pc/19_nuri.png";

import ci01t from "../images/cis/tablet/01_t_sk_telecom.png";
import ci02t from "../images/cis/tablet/02_t_logo.png";
import ci03t from "../images/cis/tablet/03_t_lg.png";
import ci04t from "../images/cis/tablet/04_t_lgu+.png";
import ci05t from "../images/cis/tablet/05_t_woongjin.png";
import ci06t from "../images/cis/tablet/06_t_gs.png";
import ci07t from "../images/cis/tablet/07_t_oliveyoung.png";
import ci08t from "../images/cis/tablet/08_t_kakaopay.png";
import ci09t from "../images/cis/tablet/09_t_tmap.png";
import ci10t from "../images/cis/tablet/10_t_logo.png";
import ci11t from "../images/cis/tablet/11_t_theres.png";
import ci12t from "../images/cis/tablet/12_t_11street.png";
import ci13t from "../images/cis/tablet/13_t_line.png";
import ci14t from "../images/cis/tablet/14_t_kt.png";
import ci15t from "../images/cis/tablet/15_t_tripstore.png";
import ci16t from "../images/cis/tablet/16_t_cyberlogitec.png";
import ci17t from "../images/cis/tablet/17_t_lig.png";
import ci18t from "../images/cis/tablet/18_t_hmm.png";
import ci19t from "../images/cis/tablet/19_t_nuri.png";

import ci01m from "../images/cis/mobile/01_m_sk_telecom.png";
import ci02m from "../images/cis/mobile/02_m_logo.png";
import ci03m from "../images/cis/mobile/03_m_lg.png";
import ci04m from "../images/cis/mobile/04_m_lgu+.png";
import ci05m from "../images/cis/mobile/05_m_woongjin.png";
import ci06m from "../images/cis/mobile/06_m_gs.png";
import ci07m from "../images/cis/mobile/07_m_oliveyoung.png";
import ci08m from "../images/cis/mobile/08_m_kakaopay.png";
import ci09m from "../images/cis/mobile/09_m_tmap.png";
import ci10m from "../images/cis/mobile/10_m_logo.png";
import ci11m from "../images/cis/mobile/11_m_theres.png";
import ci12m from "../images/cis/mobile/12_m_11street.png";
import ci13m from "../images/cis/mobile/13_m_line.png";
import ci14m from "../images/cis/mobile/14_m_kt.png";
import ci15m from "../images/cis/mobile/15_m_tripstore.png";
import ci16m from "../images/cis/mobile/16_m_cyberlogitec.png";
import ci17m from "../images/cis/mobile/17_m_lig.png";
import ci18m from "../images/cis/mobile/18_m_hmm.png";
import ci19m from "../images/cis/mobile/19_m_nuri.png";

import itemCard001 from "../images/content/item/item-card-001.png";
import itemCard002 from "../images/content/item/item-card-002.png";
import itemCard003 from "../images/content/item/item-card-003.png";
import itemCard004 from "../images/content/item/item-card-004.png";
import itemCard005 from "../images/content/item/item-card-005.png";
import itemCard006 from "../images/content/item/item-card-006.png";
import itemCard007 from "../images/content/item/item-card-007.png";
import itemCard008 from "../images/content/item/item-card-008.png";
import itemCard009 from "../images/content/item/item-card-009.png";
import itemCard010 from "../images/content/item/item-card-010.png";
import itemCard011 from "../images/content/item/item-card-011.png";
import itemCard012 from "../images/content/item/item-card-012.png";
import itemCard013 from "../images/content/item/item-card-013.png";
import itemCard014 from "../images/content/item/item-card-014.png";
import itemCard015 from "../images/content/item/item-card-015.png";
import itemCard016 from "../images/content/item/item-card-016.png";
import itemCard017 from "../images/content/item/item-card-017.png";
import itemCard018 from "../images/content/item/item-card-018.png";
import itemCard019 from "../images/content/item/item-card-019.png";
import itemCard020 from "../images/content/item/item-card-020.png";
import itemCard021 from "../images/content/item/item-card-021.png";
import itemCard022 from "../images/content/item/item-card-022.png";
import itemCard023 from "../images/content/item/item-card-023.png";
import itemCard024 from "../images/content/item/item-card-024.png";
import itemCard025 from "../images/content/item/item-card-025.png";
import itemCard026 from "../images/content/item/item-card-026.png";
import itemCard027 from "../images/content/item/item-card-027.png";
import itemCard028 from "../images/content/item/item-card-028.png";
import itemCard029 from "../images/content/item/item-card-029.png";
import itemCard030 from "../images/content/item/item-card-030.png";
import itemCard031 from "../images/content/item/item-card-031.png";
import itemCard032 from "../images/content/item/item-card-032.png";
import itemCard033 from "../images/content/item/item-card-033.png";
import itemCard034 from "../images/content/item/item-card-034.png";
import itemCard035 from "../images/content/item/item-card-035.png";
import itemCard036 from "../images/content/item/item-card-036.png";

const HeaderMenuList: IHeaderMenu[] = [
  {
    path: "service",
    name: "테스트 서비스",
    to: "/service",
    children: [
      {
        path: "outsourcing",
        name: "아웃소싱 테스트",
        to: "/service",
        desc: { 
          title: "Outsourcing Test", 
          desc: `티벨의 아웃소싱 테스트는 기업 및\n`
            +`프로젝트의 특성에 맞춘 고객 맞춤형 테스트입니다.`,
          tag: [
            "Web/App", 
            "IoT/AI", 
            "Embedded", 
            "Finance",
            "Automotive",
          ], 
        },
        show: true,
        bg: {
          pc: bgOutsourcing,
          mobile: mOutsourcing,
          tablet: tOutsourcing,
        }
      },
      {
        path: "automation",
        name: "테스트 자동화",
        to: "/service",
        desc: { 
          title: "Test Automation", 
          desc: `티벨만의 차별화된 자동화 테스트 서비스를 통해 보다\n`
            +`높은 수준의 품질 및 고객 만족 향상을 약속드립니다.`,
          tag: [
            "안전성", 
            "효율성", 
            "전문성", 
            "비용절감",
          ], 
        },
        show: true,
        bg: {
          pc: bgAutomation,
          mobile: mAutomation,
          tablet: tAutomation,
        }
      },
      {
        path: "blackbox",
        name: "블랙박스 테스트",
        to: "/service",
        desc: { 
          title: "Blackbox Test", 
          desc: `제품 개발을 위해 작성된 개발 명세서를 기반으로\n` 
            +`테스트 시나리오를 작성하고 테스트를 수행함으로써\n`
            +`제품 품질 개선 활동하는 테스트 서비스입니다.`,
          tag: [
            "Interface Test", 
            "System Test", 
            "Intergration Test", 
            "Sanity Test",
            "Regression Test",
            "Acceptanace Test",
          ], 
        },
        show: true,
        bg: {
          pc: bgBlackBox,
          mobile: mBlackBox,
          tablet: tBlackBox,
        }
      },
      {
        path: "whitebox",
        name: "화이트박스 테스트",
        to: "/service",
        desc: { 
          title: "Whitebox Test", 
          desc: `화이트박스 테스트(WhiteBox Test)기법은 소프트웨어\n`
            +`내부 소스 코드를 테스트하는 기법으로써 동작의\n`
            +`유효성 뿐만아니라 실행 되는 과정을 살펴보는 테스트입니다.`, 
          tag: ["Static Test", "Dynamic Test"], 
        },
        show: true,
        bg: {
          pc: bgWhiteBox,
          mobile: mWhiteBox,
          tablet: tWhiteBox,
        }
      },
      {
        path: "api",
        name: "API 테스트",
        to: "/service",
        desc: { 
          title: "API Test", 
          desc: `서로 다른 소프트웨어 시스템 사이에\n통신과 연동을 위해 API 테스트는 필수적입니다.`, 
          tag: ["기능", "안정성", "성능"], 
        },
        show: true,
        bg: {
          pc: bgApi,
          mobile: mApi,
          tablet: tApi,
        }
      },
      {
        path: "perfomance",
        name: "성능 테스트",
        to: "/service",
        desc: { title: "", desc: ``, tag: [], },
        show: true,
        bg: {
          pc: bgPerfomance,
          mobile: mPerfomance,
          tablet: tPerfomance,
        }
      },
    ],
  },
  {
    path: "testops",
    name: "TestOps",
    to: "/testops",
    bg: {
      pc: bgTestOps,
      mobile: mTestOps,
      tablet: tTestOps,
    },
    children: [
      {
        path: "testops",
        name: "TestOps 구축",
        to: "/testops",
        desc: { title: "TestOps 구축", desc: ``, tag: [], },
        show: true,
        bg: {
          pc: bgTestOps,
          mobile: mTestOps,
          tablet: tTestOps,
        }
      },
      {
        path: "aitest",
        name: "AI 기반 검증 자동화",
        to: "/testops",
        desc: { title: "AI 기반 검증 자동화", desc: ``, tag: [], },
        show: true,
        bg: {
          pc: bgAitest,
          mobile: mAitest,
          tablet: tAitest,
        }
      },
    ],
  },
  {
    path: "labeling",
    name: "데이터라벨링",
    to: "/labeling",
    children: [
      {
        path: "data",
        name: "데이터 서비스",
        to: "/labeling",
        desc: { title: "데이터 서비스", desc: ``, tag: [], },
        show: true,
        bg: {
          pc: bgDataservice,
          mobile: mDataservice,
          tablet: tDataservice,
        }
      },
      {
        path: "sslo",
        name: "S.S.L.O",
        to: "/labeling",
        desc: { 
          title: "S.S.L.O", 
          desc: "친환경 제품 및 서비스, 에너지 소비 분야를 중심으로 친환경 ICT 기업 도약을 추진합니다.", 
          sub: `친환경 제품 및 서비스, 에너지 소비 분야를 중심으로\n친환경 ICT 기업 도약을 추진합니다.`,
          tag: [], 
        },
        show: true,
        bg: {
          pc: bgSSLO,
          mobile: mSSLO,
          tablet: tSSLO,
        }
      },
    ],
  },
  {
    path: "tassi",
    name: "T-ASSI",
    to: "http://t-assi.co.kr/",
    children: [
      {
        path: "tassi",
        name: "T-ASSI 소개",
        to: "http://t-assi.co.kr/service",
        desc: { title: "T-ASSI 소개", desc: ``, tag: [], },
        show: true,
        bg: null,
      },
    ],
  },
  {
    path: "info",
    name: "회사소개",
    to: "/info",
    children: [
      {
        path: "information",
        name: "회사소개",
        to: "/info",
        desc: { title: "회사 소개", desc: ``, tag: [], },
        show: true,
        bg: {
          pc: bgInfo,
          mobile: mInfo,
          tablet: tInfo,
        }
      },
      {
        path: "vision",
        name: "경영철학",
        to: "/info",
        desc: { title: "경영철학", desc: ``, tag: [], },
        show: true,
        bg: {
          pc: bgVision,
          mobile: mVision,
          tablet: tVision,
        }
      },
      {
        path: "benefit",
        name: "복리후생",
        to: "/info",
        desc: { title: "복리후생", desc: ``, tag: [], },
        show: true,
        bg: {
          pc: bgBenefit,
          mobile: mBenefit,
          tablet: tBenefit,
        }
      },
      {
        path: "recruit",
        name: "인재채용",
        to: "/info",
        desc: { 
          title: "Good Player, Great Work Place", 
          desc: "티벨은 올바른 생각과 실천을 통해 “우수한 인재를, 일하기 좋은 기업”을 만듭니다.", 
          sub: `티벨은 올바른 생각과 실천을 통해 “우수한 인재를,\n 일하기 좋은 기업”을 만듭니다.`,
          tag: [], 
        },
        show: true,
        bg: {
          pc: bgRecruit,
          mobile: mRecruit,
          tablet: tRecruit,
        }
      },
      {
        path: "blog",
        name: "Blog",
        to: "/info",
        desc: { title: "Blog", desc: ``, tag: [], }, 
        show: true,
        bg: {
          pc: bgBlog,
          mobile: mBlog,
          tablet: tBlog,
        }
      },
    ],
  },
  {
    path: "management",
    name: "지속가능경영",
    to: "/management",
    bg: {
      pc: bgManagement,
      mobile: mManagement,
      tablet: tManagement,
    },
    children: [
      {
        path: "management",
        name: "지속가능경영",
        to: "/management",
        desc: { title: "지속가능 경영", desc: ``, tag: [], },
        show: false,
        bg: {
          pc: bgManagement,
          mobile: mManagement,
          tablet: tManagement,
        }
      },
      {
        path: "ethical",
        name: "윤리경영",
        to: "/management",
        desc: { title: "윤리 경영", desc: ``, tag: [], },
        show: true,
        bg: {
          pc: bgEthical,
          mobile: mEthical,
          tablet: tEthical,
        }
      },
      {
        path: "social",
        name: "사회경영",
        to: "/management",
        desc: { title: "사회 경영", desc: ``, tag: [], },
        show: true,
        bg: {
          pc: bgSocial,
          mobile: mSocial,
          tablet: tSocial,
        }
      },
      {
        path: "environmental",
        name: "환경경영",
        to: "/management",
        desc: { 
          title: "환경 경영", 
          desc: `친환경 제품 및 서비스, 에너지 소비 분야를 중심으로 친환경 ICT 기업 도약을 추진합니다.`, 
          sub: `친환경 제품 및 서비스, 에너지 소비 분야를 중심으로\n친환경 ICT 기업 도약을 추진합니다.`,
          tag: [], 
        },
        show: true,
        bg: {
          pc: bgEnviron,
          mobile: mEnviron,
          tablet: tEnviron,
        }
      },
    ],
  },
  {
      path: "contact",
      name: "사업문의",
      to: "/contact",
      bg: {
        pc: bgContact,
        mobile: mContact,
        tablet: tContact,
      },
      children: [
        {
          path: "contact",
          name: "사업문의 신청",
          to: "/contact",
          desc: { title: "사업문의 신청", desc: ``, tag: [], },
          show: true,
          bg: {
            pc: bgContact,
            mobile: mContact,
            tablet: tContact,
          }
        },
      ],
    },
];

const MainBannerList: IBanner[] = [
  {
    pc: banner01,
    tablet: banner01t,
    mobile: banner01m,
    title: {
      pc: `차별화된 테스트 경험을 제공해 드리는\n대한민국 대표 품질 서비스 기업`,
      tablet: `차별화된 테스트 경험을 제공해 드리는\n대한민국 대표 품질 서비스 기업`,
      mobile: `차별화된 테스트 경험을\n제공해 드리는\n대한민국 대표 품질 서비스 기업`,
    },
    desc: {
      pc: `대한민국 IT 산업에 품질 기여하고자 테스트에 대한 방법론과 서비스를 차별화하여\n테스트 서비스의 패러다임 변화를 주도하고 있습니다.`,
      tablet: `대한민국 IT 산업에 품질 기여하고자 테스트에 대한 방법론과 서비스를\n차별화하여 테스트 서비스의 패러다임 변화를 주도하고 있습니다.`,
      mobile: `대한민국 IT 산업에 품질 기여하고자 테스트에 대한\n방법론과 서비스를 차별화하여 테스트 서비스의\n패러다임 변화를 주도하고 있습니다.`,
    },
    bgColor: null,
    isFull: "no",
  }
];

const CIList = [
  {
    pc: ci01,
    tablet: ci01t,
    mobile: ci01m
  },
  {
    pc: ci02,
    tablet: ci02t,
    mobile: ci02m
  },
  {
    pc: ci03,
    tablet: ci03t,
    mobile: ci03m
  },
  {
    pc: ci04,
    tablet: ci04t,
    mobile: ci04m
  },
  {
    pc: ci05,
    tablet: ci05t,
    mobile: ci05m
  },
  {
    pc: ci06,
    tablet: ci06t,
    mobile: ci06m
  },
  {
    pc: ci07,
    tablet: ci07t,
    mobile: ci07m
  },
  {
    pc: ci08,
    tablet: ci08t,
    mobile: ci08m
  },
  {
    pc: ci09,
    tablet: ci09t,
    mobile: ci09m
  },
  {
    pc: ci10,
    tablet: ci10t,
    mobile: ci10m
  },
  {
    pc: ci11,
    tablet: ci11t,
    mobile: ci11m
  },
  {
    pc: ci12,
    tablet: ci12t,
    mobile: ci12m
  },
  {
    pc: ci13,
    tablet: ci13t,
    mobile: ci13m
  },
  {
    pc: ci14,
    tablet: ci14t,
    mobile: ci14m
  },
  {
    pc: ci15,
    tablet: ci15t,
    mobile: ci15m
  },
  {
    pc: ci16,
    tablet: ci16t,
    mobile: ci16m
  },
  {
    pc: ci17,
    tablet: ci17t,
    mobile: ci17m
  },
  {
    pc: ci18,
    tablet: ci18t,
    mobile: ci18m
  },
  {
    pc: ci19,
    tablet: ci19t,
    mobile: ci19m
  },
];

const ServiceFieldList = [
  {
    id: "01",
    title: "WEB/APP",
    image: field01,
    desc: `우리가 매일 접하는 분야로\n업그레이드 주기가 빠른 것이 특징입니다.\n릴리즈 계획에 맞춰 신속하지만 신뢰성이\n높은 테스트를 실행하고 있습니다.`,
  },
  {
    id: "02",
    title: "IoT/APP",
    image: field02,
    desc: `최신 트랜드로 주목 받고 있는 분야로\n전문지식을 바탕으로 IoT/AI 관련 제품 및\n시스템을 테스트하고 있습니다.`,
  },
  {
    id: "03",
    title: "Embedded",
    image: field03,
    desc: `기계/전자 장치의 효율적인 제어를 위한\n임베디드 적용제품에 다각도의 기법을\n적용하여 테스트 진행을 하고 있습니다.`,
  },
  {
    id: "04",
    title: "Finance",
    image: field04,
    desc: `고도의 신뢰성을 요하는 분야로\n금융산업에 대한 높은 이해와 전문적인 테스트\n기술을 도입하고 있습니다.`,
  },
  {
    id: "05",
    title: "Automotive",
    image: field05,
    desc: `복잡하고 다양한 기술이 탑재되어 있으며\n정밀성을 요하는 분야입니다.\n최고의 인재들과 정밀성 높은 테스트 기법으로\n테스트 수행을 하고 있습니다.`,
  },
];

const CommissionFieldList = [
  {
    title: "01. 테스트 대상",
    contents: [
      {
        title: "Application",
        type: "App",
      },
      {
        title: "Web System",
        type: "Web",
      },
      {
        title: "Mobile App",
        type: "MoA",
      },
      {
        title: "Embedded",
        type: "Emb",
      },
      {
        title: "IoT",
        type: "IoT",
      },
      {
        title: "직접 입력",
        type: "Etc",
      },
    ],
  },
  {
    title: "02. 테스트 종류",
    contents: [
      {
        title: "기능 테스트",
        type: "Fn",
      },
      {
        title: "Whitebox Test",
        type: "Wx",
      },
      {
        title: "OLST",
        type: "Ol",
      },
      {
        title: "Auto Test Process",
        type: "At",
      },
      {
        title: "아키텍트 (SE)",
        type: "SE",
      },
      {
        title: "성능",
        type: "Pf",
      },
      {
        title: "고객평가 UX",
        type: "Ux",
      },
    ],
  },
];

const DataBuildInstanceList = [
  {
    title: {
      pc: "한우 특이행동 인식 데이터",
      mobile: "한우 특이행동 인식 데이터",
      tablet: `한우 특이행동\n인식 데이터`,
    },
    desc: `축사 내 한우의 번식 시기\n예측을 위한 특이행동\n인식 데이터 셋 구축`,
    image: build01,
  },
  {
    title: {
      pc: "반려견 얼굴 인식 데이터",
      mobile: "반려견 얼굴 인식 데이터",
      tablet: `반려견 얼굴\n인식 데이터`,
    },
    desc: `메타버스의 반려 동물 외형\n3D 구현 기술을 위한\n반려견 얼굴 인식 데이터 셋 구축`,
    image: build02,
  },
  {
    title: {
      pc: "식품 정보 인식 데이터",
      mobile: "식품 정보 인식 데이터",
      tablet: `식품 정보\n인식 데이터`,
    },
    desc: `개인 맞춤형 건강 관리\n서비스 제공을 위해\n이미지 내 음식 칼로리\n정보 인식 데이터 셋 구축`,
    image: build03,
  },
  {
    title: {
      pc: "버섯 곰팡이 인식 데이터",
      mobile: "버섯 곰팡이 인식 데이터",
      tablet: `버섯 곰팡이\n인식 데이터`,
    },
    desc: `곰팡이 발생 버섯 배지\n자동 제거를 위한\n곰팡이 균 탐지 및\n면적 인식 데이터 셋 구축`,
    image: build04,
  },
  {
    title: {
      pc: "인간 피부 상태 인식 데이터",
      mobile: "인간 피부 상태 인식 데이터",
      tablet: `인간 피부 상태\n인식 데이터`,
    },
    desc: `개인 맞춤형 화장품 추천을 위한\n피부 내 결점 사항 인식\n데이터 셋 구축`,
    image: build05,
  },
  {
    title: {
      pc: "의류 착용 상태 인식 데이터",
      mobile: "의류 착용 상태 인식 데이터",
      tablet: `의류 착용 상태\n인식 데이터`,
    },
    desc: `상·하의 착용 상태 인식하여\n가상피팅 서비스 제공을 위한\n데이터 셋 구축`,
    image: build06,
  },
  {
    title: {
      pc: "스포츠 동작 인식 데이터",
      mobile: "스포츠 동작 인식 데이터",
      tablet: `스포츠 동작\n인식 데이터`,
    },
    desc: `축구·농구 등 역동적인 운동 동작을\n인식하여 코칭 서비스 제공을 위한\n스포츠 동작 인식 데이터 셋 구축`,
    image: build07,
  },
  {
    title: {
      pc: "교통 약자 행동 인식 데이터",
      mobile: "교통 약자 행동 인식 데이터",
      tablet: `교통 약자 행동\n인식 데이터`,
    },
    desc: `교통 시설의 효율적 운영을 위한\n교통 약자 인식 데이터 셋 구축`,
    image: build08,
  },
  {
    title: {
      pc: "피트니스 자세 교정 데이터",
      mobile: "피트니스 자세 교정 데이터",
      tablet: `피트니스 자세\n교정 데이터`,
    },
    desc: `체형 불균형 및 통증 원인을\n분석하여 개인 별 피트니스 코칭을\n제공하기 위한 피트니스 자세\n데이터 셋 구축`,
    image: build09,
  },
  {
    title: {
      pc: "부품 결함 인식 데이터",
      mobile: "부품 결함 인식 데이터",
      tablet: `부품 결함\n인식 데이터`,
    },
    desc: `고품질 제품 생산을 위한\n부품 내 결함 인식 데이터 셋 구축`,
    image: build10,
  },
  {
    title: {
      pc: "전력량계 OCR 데이터",
      mobile: "전력량계 OCR 데이터",
      tablet: `전력량계 OCR\n데이터`,
    },
    desc: `전기요금 실시간 측정\n서비스 제공을 위한\n전력량계 OCR 데이터 셋 구축`,
    image: build11,
  },
  {
    title: {
      pc: "맞춤형 리뷰 정보 데이터",
      mobile: "맞춤형 리뷰 정보 데이터",
      tablet: `맞춤형 리뷰\n정보 데이터`,
    },
    desc: `온라인 쇼핑몰 리뷰\n통합 관리를 위한\n리뷰 데이터 감성 분석\n데이터 셋 제작`,
    image: build12,
  },
  {
    title: {
      pc: "감성 분석 태깅 데이터",
      mobile: "감성 분석 태깅 데이터",
      tablet: `감성 분석\n태깅 데이터`,
    },
    desc: `온라인 심리 셀프 케어\n솔루션 제공을 위한\n사용자 생성 문장 내\n감성 분석 태깅 데이터 셋 구축`,
    image: build13,
  },
];

const DomainList = [
  {
    title: "금융",
    image: domain01,
  },
  {
    title: "영상",
    image: domain02,
  },
  {
    title: "보안",
    image: domain03,
  },
  {
    title: "자동차",
    image: domain04,
  },
  {
    title: "전자",
    image: domain05,
  },
  {
    title: "임베디드",
    image: domain06,
  },
  {
    title: "전자상거래",
    image: domain07,
  },
  {
    title: "통신",
    image: domain08,
  },
  {
    title: "플랫폼",
    image: domain09,
  },
  {
    title: "공공분야",
    image: domain10,
  },
]

const InfoHistoryList = [
  {
    year: 2023,
    datas: [
      { month: 0, title: "외부수상", desc: [
        "- 2023년도 SK텔레콤 최우수파트너사 수상", 
        "- KOSA 주관 소프트웨어 산업발전 유공자 과학기술부 장관 표창"
      ] },
      { month: 0, title: "계약체결", desc: [
        "- CJ올리브영 올리브원 물류서비스 시스템 품질 관리 신규 계약 체결",
        "- 우아한형제들 배달의민족 서비스 QA 신규 계약 체결"
      ]},
      { month: 0, title: "협약체결", desc: ["- TTA아카데미 MOU 협약 체결"] },
    ] 
  },
  {
    year: 2022,
    datas: [
      { month: 0, title: "계약체결", desc: [
        "- 웅진씽크빅 웅진북클럽 & 스마트올 플랫폼의 품질관리 신규 계약 체결",
        "- 티맵모빌리티 TMAP TDE 이관 및 TMOBI 업무 인프라 운영 신규 계약 체결",
        "- 한국데이터산업진흥원 데이터바우처지원 신규 계약 체결",
        "- 슈어소프트테크 가동원전 제어계측계통 디지털화 기술 개발 신규 계약 체결"
      ]},
      { month: 0, title: "외부수상", desc: ["- 동반성장 Pride Awards 동반성장 최우수 협력상 수상"] },
      { month: 0, title: "지사설립", desc: ["- 가산 사무실 신설(서울특별시 금천구 가산디지털1로 168, 우림라이온스밸리)"] },
      { month: 0, title: "협약체결", desc: [
        "- 휴먼교육센터 천안지점 K-디지털 트레이닝 디지털 신기술 핵심 실무인재 양성 협약 체결",
        "- 디코드컴퓨터학원 협약 체결",
        "- 휴면교육센터 수원지점 K-디지털 트레이닝 디지털 신기술 핵심 실무인재 양성 협약 체결",
        "- 대한상공회의소 서울기술교육센터 국가인적자원개발 컨소시엄 전략분야 인력양성기업 협약 체결",
        "- 메가스터디아카데미 산학협력 MOU 협약 체결",
        "- 서울중부남부기술교육원 기업협력형 교육과정 운영지원 협약 체결",
        "- 동부여성새로일하기센터 여성친화일촌기업 협약 체결"
      ]},
    ] 
  },
  {
    year: 2021,
    datas: [
      { month: 0, title: "계약체결", desc: ["- 엑스퍼넷 LIG넥스원 SLM Atlassian Data Center 구축 신규 계약 체결"] },
      { month: 0, title: "기부활동", desc: ["- 아동복지단체(강서좋은친구복지센터, 강남청소년상담복지센터) 코로나 방역용품 전달"] },
      { month: 0, title: "본사이전", desc: ["- 티벨 본사이전(서울특별시 강남구 강남대로 354, 혜천빌딩)"] },
      { month: 0, title: "외부수상", desc: [
        "- 2021년 제5회 SW테스트디자인콘테스트 과학기술정보통신 장관상 수상",
        "- SKT 동반성장 Pride Awards 2021 Partnership 수상"
      ]},
      { month: 0, title: "외부행사", desc: [
        "- AI EXPO 전시회 참가",
        "- 한국전기산업대전 전시회 참가",
        "- WORLD IT SHOW 전시회 참가",
        "- 부산 AI EXPO 전시회 참가",
        "- BIXPO 2021 전시회 참가",
        "- 베스트콘 2021 참가",
        "- 연세대학교 SW중심대학사업단 2021년 산학공동프로젝트 참석"
      ]},
      { month: 0, title: "특허출원", desc: ["- '이미지 인식 기반 전력량 분석 정보를 제공하는 방법, 컴퓨팅 장치 및 \n\t컴퓨터 프로그램 특허' (특허번호 : 제 10-2280306 호) 특허 출원"] },
      { month: 0, title: "협약체결", desc: [
        "- 한국산업기술대학과 가족회사협약서 체결",
        "- 연세대학교 산학협력 협약 체결",
        "- 일터혁신컨설팅 협약 체결",
        "- 동부여성새로일하기센터 직업교육훈련(SW테스터양성과정) 훈련 운영 업무 협약 체결"
      ]},
    ] 
  },
  {
    year: 2020,
    datas: [
      { month: 0, title: "계약체결", desc: [
        "- 한국정보통신기술협회 신규 계약 체결",
        "- 카카오페이 제품 검수/테스트 신규 계약 체결",
        "- 재단법인 한국데이터산업진흥원 계약 체결",
        "- 이투스교육 이투스 수강APP 평점/품질관리 신규 계약 체결",
      ]},
      { month: 0, title: "기부활동", desc: ["- 아동복지단체(강서좋은친구복지센터) 크리스마스 선물 전달"] },
      { month: 0, title: "외부수상", desc: ["- 동반성장 최우수 협력기업 표창장 수상"] },
      { month: 0, title: "외부행사", desc: [
        "- 2020 국제인공지능대전 (AI EXPO KOREA) 참가",
        "- SOUTHEAST Digital Transformation Challenge Round Table (DT) 참가",
      ]},
      { month: 0, title: "외부인증", desc: ["- 벤처기업 인증"] },
      { month: 0, title: "협약체결", desc: [
        "- 인재 양성을 위한 배화여자대학교 MOU 체결",
        "- 인재 양성을 위한 인하공전전문대학 MOU 체결",
        "- 강서여성인력개발센터와 협약 체결",
        "- KEPCO 에너지 스타트업 협약 체결"
      ]},
    ] 
  },
  {
    year: 2019,
    datas: [
      { month: 0, title: "계약체결", desc: [
        "- 라인플러스 광고/서비스 플랫폼 신규 계약 체결",
        "- 하나은행 금융 플랫폼(하나원큐, 퇴직연금) 신규 계약 체결",
        "- SK텔레콤 NUGU서비스 추가 계약 체결"
      ]},
      { month: 0, title: "기부활동", desc: ["- 아동복지단체(강서좋은친구복지센터) 노트북 10대 기부"] },
      { month: 0, title: "외부행사", desc: ["- JaSST(Japan Symposium on Software Testing) 2019 심포지엄 참석", "- 대기업 우수 협력사 PR 챌린지 참여"] },
      { month: 0, title: "외부행사", desc: ["- 대기업 우수 협력사 PR 챌린지 참여"] },
      { month: 0, title: "외부인증", desc: ["- 한국소프트웨어산업협회 정회원 등록"] },
      { month: 0, title: "특허이전", desc: [
        `- '서비스 요청과 응답의 연결이 분리된 웹 응용프로그램의 성능 측정장치 및 방법'\n\t(특허번호 : 제 10-1241805 호) 특허 이전`,
        `- '영상의 인트라 예측 장치'\n\t(특허번호 : 제 10-1307257 호) 특허 이전`, 
        `- '모니터링 기능을 이용한 데이터베이스 관리 방법 및 그 장치'\n\t(특허번호 : 제 10-0868195 호) 특허 이전`,
        `- '통화 품질 맵 작성 시스템 및 방법'\n\t(특허번호 : 제 10-1001474 호) 특허 이전`,
        `- '무선통신망의 품질측정위치를 판단하는 단말 및 방법'\n\t(특허번호 : 제 10-1160058 호) 특허 이전`,
        `- '이동통신 서비스의 품질측정 시스템 및 방법'\n\t(특허번호 : 제10-0726601 호) 특허 이전`,
      ]},
    ] 
  },
  {
    year: 2018,
    datas: [
      { month: 0, title: "본사이전", desc: ["- 티벨 본사이전(서울특별시 강서구 공항대로 227, 마곡센트럴타워 1차)"] },
      { month: 0, title: "외부수상", desc: ["- KOSTA SW테스팅 발전 공로상 수상"] },
      { month: 0, title: "협약체결", desc: ["- SK텔레콤 동반성장 협약 체결"] },
    ] 
  },
  {
    year: 2017,
    datas: [
      { month: 0, title: "외부인증", desc: ["- 한국소프트웨어테스트협의회 회원사 등록"] },
    ] 
  },
  {
    year: 2016,
    datas: [
      { month: 0, title: "계약체결", desc: ["- SK텔레콤 WEB/APP 신규 계약 체결"] },
      { month: 0, title: "외부인증", desc: ["기업부설연구소 설립"] },
    ] 
  },
  {
    year: 2015,
    datas: [
      { month: 5, title: "본사설립", desc: ["- 주식회사 티벨 설립(서울특별시 금천구 서부샛길 606, 대성디폴리스)"] },
    ] 
  }
];

const OfficeList: IOffice[] = [
  {
    name: "강남 본사",
    address: "서울특별시 강남구 강남대로 354, 9층 (역삼동, 혜천빌딩)",
    tel: "070-7777-9113 / 070-7777-6368",
    email: "staff@tbell.co.kr",
    lat: 37.49470173056075,
    lng: 127.02974046884096,
  },
  {
    name: "가산 사업장",
    address: "서울특별시 금천구 가산디지털1로 168, A동 601호 (우림라이온스밸리 A동)",
    tel: "070-7777-9113 / 070-7777-6368",
    email: "staff@tbell.co.kr",
    lat: 37.480764409783355,
    lng: 126.88213997302407,
  }
];

const DataUsedExampleList = [
  {
    title: "스마트 홈",
    contents: `가정용 로봇\n지능형 스피커`,
    image: itemSSLO001,
  },
  {
    title: "교통",
    contents: `자율주행 차량\n교통사고 정보 전달\n실시간 교통상황 감지`,
    image: itemSSLO002,
  },
  {
    title: "유통",
    contents: `택배 자동 분류\n무인점포\n드론/로봇 택배\n매장 재고 관리 로봇`,
    image: itemSSLO003,
  },
  {
    title: "교육",
    contents: `화상 학습\n가상현실 교육\n교육용 로봇`,
    image: itemSSLO004,
  },
  {
    title: "법률",
    contents: `법률 상담 및 검색\n법률 문서 작성\n법률 자문 및 전략 수립`,
    image: itemSSLO005,
  },
  {
    title: "금융",
    contents: `맞춤형 자산관리\n챗봇 상담`,
    image: itemSSLO006,
  },
  {
    title: "의료",
    contents: `암 진단\n환자 관리\n심장질환 예측\n간병 로봇`,
    image: itemSSLO007,
  },
  {
    title: "보안",
    contents: `순찰로봇\nCCTV 모니터링\n범죄예측`,
    image: itemSSLO008,
  },
  {
    title: "예술",
    contents: `영화 예고편 편집\n시나리오 작성\n로봇 기자`,
    image: itemSSLO009,
  },
  {
    title: "기타",
    contents: `시각 장애인용 사물 음성 설명\n개인 트레이너\n감정 파악`,
    image: itemSSLO010,
  }
];

const AutoLabelingContentList = [
  {
    type: "HD",
    image: itemHD,
    title: "(Human Detection)",
    desc: `\n클릭 한 번 만으로 이미지 내에서\n사람을 인식 하여 경계 상자와 모양을 예측합니다.`,
  },
  {
    type: "OD",
    image: itemOD,
    title: "(Object Detection)",
    desc: `\n클릭 한 번 만으로 이미지 내에서 원하는\n객체를 찾아 경계 상자를 예측합니다.`,
  },
  {
    type: "IS",
    image: itemIS,
    title: "(Instance Segmentation)",
    desc: `\n클릭 한 번 만으로 이미지 내에서 원하는\n객체를 찾아 해당 객체의 모양을 예측합니다.`,
  },
  {
    type: "SES",
    image: itemSES,
    title: "(Sementic Segmentation)",
    desc: `\n클릭 한 번 만으로 이미지 내에서\n각 픽셀이 어느 객체에 해당하는 지 분류하여\n해당 객체의 모양을 예측합니다.`,
  },
];

const CardNewsList = [
  {
		title: "[23년 3분기 게릴라 이벤트] 워터파크 이용권 후기",
    id: "223234609460",
    sub: "2023年 ",
    category: "티벨일상",
    created: "2023.10.12",
    img: itemCard001,
    content: `안녕하세요! #티벨 입니다. 돌아온 3분기 게릴라 이벤트! 열심히 일하고 계시는 구성원분들을 위해 뜨거운 여름을 맞이하여 시원하게 즐길 수 있는 워터파크 이용권을 준비하였습니다!`,
	},
  {
		title: "[23년 2분기 게릴라이벤트] 5/20 소노벨비발디파크, 쏠비치 삼척 후기이용권 후기",
    id: "223124480157",
    sub: "2023年 ",
    category: "티벨일상",
    created: "2023.06.09",
    img: itemCard002,
    content: `안녕하세요! #티벨 입니다. 지난번 2분기 게릴라 이벤트 후기 1탄을 들고 왔는데요! 이번에도 어김없이 이벤트 후기 2탄을 들고 왔습니다 ㅎㅎ`,
	},
  {
		title: "[속보] 티벨 KBS 9시 뉴스 출연!",
    id: "223118337891",
    sub: "2023年 ",
    category: "티벨일상",
    created: "2023.06.02",
    img: itemCard003,
    content: `안녕하세요. #티벨 입니다. 티벨이 KBS 9시 뉴스에 출연을 하게 되었습니다! 주제는 바로! [직장에 복귀한 워킹맘]입니다. 귀하신 분이 저희`,
	},
  {
		title: "2023년 1분기 게릴라 이벤트",
    id: "223049989083",
    sub: "2023年 ",
    category: "티벨일상",
    created: "2023.03.20",
    img: itemCard004,
    content: `안녕하세요! #티벨 입니다! 분기별 #게릴라이벤트 를 진행하겠습니다! 라고 2022년 종무식때 임직원분들과 약속을 했습니다.\n\n`
    +`임직원분들과의 약속인 만큼 무슨 이벤트를 진행할지 많은 고민을 하였는데요~ 고민 끝에 정한 이벤트는 #뮤지컬관람 입니다!`,
	},
  {
		title: "2023년 2월 칭찬 티벨러",
    id: "223033319077",
    sub: "2023年 ",
    category: "티벨일상",
    created: "2023.03.03",
    img: itemCard005,
    content: `안녕하세요! #티벨 입니다. 23년 2월의 #칭찬사원 은 과연 누구일까요?전광희 파트장님 축하드립니다! 전광희 파트장님께서는 "회사에서 진행하는 사내추천의 중요성을 이해해주`,
	},
  {
		title: "2023년 1월 칭찬 티벨러",
    id: "223011193431",
    sub: "2023年 ",
    category: "티벨일상",
    created: "2023.02.10",
    img: itemCard006,
    content: `저희 티벨에서는 매달 #칭찬사원 을 선정하고 있습니다. 여기서 칭찬사원이란? 회사 생활에서 임직원 및 고객사 분들과 업무를 수행함에 있어`,
	},
  {
		title: "2022년 종무식",
    id: "222980034478",
    sub: "2022年 ",
    category: "티벨일상",
    created: "2023.01.10",
    img: itemCard007,
    content: `안녕하세요!#티벨 입니다. 어느덧 2023년 1월 중순이 다되어 가네요! 여러분들에게 22년은 어떠셨나요? 티벨은 창립일 이후 처음으로 전 직원이 모이는 뜻깊은 행사를 진행하였습니다~`,
	},
  {
		title: "2022年 베스트콘",
    id: "222943531908",
    sub: "2022年 ",
    category: "티벨일상",
    created: "2022.12.01",
    img: itemCard008,
    content: `작년에도 2021 베스트콘을 참석하였는데요! 올해도 2022 베스트콘을 참석하게 되었습니다~ 제 8회 국제 품질 테스팅 콘퍼런스 베스트콘`,
	},
  {
		title: "2022년 단체복 (feat.필로우디)",
    id: "222913261184",
    sub: "2022年 ",
    category: "티벨일상",
    created: "2022.10.28",
    img: itemCard009,
    content: `안녕하세요! (주)티벨 입니다. 급격한 온도차이에 많은 추위를 느끼고 있는데요, 급격히 추워진 날씨에 대비하고자 단체복 제작을 하였습니다! 그럼 티벨의 단체복을 함께 보러 가실까요~?!`,
	},
  {
		title: "2022년 깜짝 이벤트(feat. 동반성장 Pride Awards 2021)",
    id: "222868168483",
    sub: "2022年 ",
    category: "티벨일상",
    created: "2022.09.06",
    img: itemCard010,
    content: `안녕하세요! (주)티벨 입니다. 다들 태풍 힌남도로 인한 피해는 많이 없으신가요? 많은 피해 없이 무사히 지나갔으면 좋겠습니다.`,
	},
  {
		title: "2022년 하반기 진급식 및 TDC 수상",
    id: "222858626657",
    category: "NewsLetter",
    created: "2022.08.26",
    img: itemCard011,
    content: `안녕하세요! (주)티벨 입니다. 올해부터 진급자를 대상으로 간소하게 진급식을 진행하고 있습니다! 진급자들에게 소소한 선물 증정 및 앞으로의 티벨의 방향성을 함께 논의하는 자리를 가지고 있습니다!`,
	},
  {
		title: "가산 사무실 신설 안내드립니다.",
    id: "222794648194",
    sub: "2022年 ",
    category: "티벨일상",
    created: "2022.06.30",
    img: itemCard012,
    content: `안녕하세요! (주)티벨 입니다. 더 나은 서비스를 제공하고자 가산 사무실을 신설하였습니다! 앞으로도 고객과 직원들이 만족하는 티벨이 되도록 노력하겠습니다.`,
	},
  {
		title: "2021年 베스트콘 및 장관상 수상",
    id: "222714562008",
    sub: "2021年 ",
    category: "티벨일상",
    created: "2022.04.28",
    img: itemCard013,
    content: `안녕하세요! 티벨 입니다~ 오랜만에 게시글로 인사 드립니다! 티벨은 지난 2021년 11월 12일(금)에 진행한 제 7회 국제 품질 테스팅 콘퍼런스`
    +`베스트콘 (Better Software Testing Conference) 2021에 참여하였습니다~`,
	},
  {
		title: "티벨 가정의 달 랜선대회",
    id: "222529727370",
    sub: "2021年 ",
    category: "티벨일상",
    created: "2021.10.07",
    img: itemCard014,
    content: `안녕하세요~오랜만에 인사드려요!(주)티벨 입니다. 오늘은 지난 5월 가정의 달 을 맞이하여 사내 온라인 행사 진행 건에 대해 소개드립니다~`,
	},
  {
		title: "2021年 1月 효도 지원금",
    id: "222221836191",
    sub: "2021年 ",
    category: "티벨일상",
    created: "2021.01.27",
    img: itemCard015,
    content: `안녕하세요! 티벨  입니다! ☺ \n2021년 첫 효도지원금을 오늘 수령 하셨답니다! 그래서 오늘은 티벨의 복리후생 중 하나인 `,
	},
  {
		title: "TBELL NEWSLETTER Vol.18",
    id: "222207381694",
    category: "NewsLetter",
    created: "2021.01.14",
    img: itemCard016,
    content: `TBELL NEWSLETTER Vol.18 - 2020.12.31 발행 기획 - 2020 SW 테스팅 정리 이슈 - Quality Assurance to Agile Quality(QA2AQ)동향 - AI 소프트웨어 테스팅 기술`,
	},
  {
		title: "좋은 친구 청소년 지역아동센터 후원",
    id: "222188062447",
    sub: "2020年 ",
    category: "티벨일상",
    created: "2020.12.28",
    img: itemCard017,
    content: `아래 사진은 5인이상 사적모임금지 지침 이전에 촬영된 사진입니다. 안녕하세요 티벨 입니다~ 다시 코로나가 심해지면서 다들 많이 힘드시죠ㅠㅠ 그래서 티벨에서 따듯하고`,
	},
  {
		title: "2021 신년선물전달",
    id: "222180900739",
    sub: "2020年 ",
    category: "티벨일상",
    created: "2020.12.21",
    img: itemCard018,
    content: `안녕하세요 (주)티벨 입니다! 2021년까지 얼마 안남았는데요?! 이번에 저희 회사에서 임직원분들을 위한 신년선물전달이 있었습니다!`,
	},
  {
		title: `2020 "SK동반성장 대상 시상식"`,
    id: "222176362157",
    category: "티벨 행사기록",
    created: "2020.12.17",
    img: itemCard019,
    content: `안녕하세요 (주)티벨 입니다. 연말 하면 시상식 을 빼놓을 수 없죠 저희 티벨도 SKT 협력사로서 "2020 동반성장 대상 시상식"에 참여했습니다~`,
	},
  {
		title: "인하공업전문대 SW테스트 실무 특별강연",
    id: "222159735799",
    sub: "2020年 ",
    category: "티벨일상",
    created: "2020.12.01",
    img: itemCard020,
    content: `안녕하세요 TBELL 입니다. 오늘은 11월27일 인하공업전문대학교 방문하여 sw테스트 실무를 주제로 정보통신과 학생들을 대상으로 정○○ 실장님께서 특별 강연을 하는 시간`,
	},
  {
		title: `TBELL 복리후생 "장기근속자 포상"`,
    id: "222154378628",
    category: "티벨 행사기록",
    created: "2020.11.25",
    img: itemCard021,
    content: `안녕하세요 (주)티벨 입니다. 오늘은 티벨의 복지중 하나인 장기근속자 포상 소개 해드리고자 합니다. 올해 장기 근속자 포상은 제주 리더워크숍 진행중 전달 하였습니다~`,
	},
  {
		title: "티벨의 전문상담사님 소개해 드립니다!",
    id: "222129544617",
    category: "티벨 행사기록",
    created: "2020.10.28",
    img: itemCard022,
    content: `안녕하세요 티벨이에요 회사 복지 자랑하려고 왔습니다~! 업무가 잘 풀리지 않으면 답답하고 삶의 회의감이 들 때 누구나 있지 않을까요?`,
	},
  {
		title: "TBELL NEWSLETTER Vol.17",
    id: "222123140825",
    category: "NewsLetter",
    created: "2020.10.22",
    img: itemCard023,
    content: `TBELL NEWSLETTER Vol.17 - 2020.10.22 발행 Technology & Issue in Software Testing 기획 - 인공지능이 QA나 다른 기술직들을 흡수할 것인가?`,
	},
  {
		title: "2020 국제인공지능대전 온라인 초청장",
    id: "222120365623",
    category: "티벨 행사기록",
    created: "2020.10.19",
    img: itemCard024,
    content: `안녕하세요~! 티벨이 참여한 EXPO에서 개막하는 2020 국제인공지능대전 온라인 초청장 소개해 드리려고 해요 국제인공지능대전 간단하게 소개해드리자면`,
	},
  {
		title: "TBELL NEWSLETTER Vol.16",
    id: "222082491667",
    category: "NewsLetter",
    created: "2020.09.07",
    img: itemCard025,
    content: `성공적인 2020 인공지능대전 전시회 마치고 돌아온 티벨이에요~! 코로나 때문에 오랜만에 열린 전시회라 준비한 리플렛이 다 떨어질 정도로 많은 분들이 오셨어요`,
	},
  {
		title: "TBELL NEWSLETTER Vol.15",
    id: "222029368938",
    category: "NewsLetter",
    created: "2020.07.13",
    img: itemCard026,
    content: `TBELL NEWSLETTER Vol.15 - 2020.07.13 발행\n`
    +`01. 기획 - SW 진흥법 전부개정안 통과\n`
    +`02. 이슈 - 디지털 헬스케어 소프트웨어 테스트\n`
    +`03. 동향 - 자동차 소프트웨어 최신 기술`,
	},
  {
		title: "TBELL NEWSLETTER Vol.14",
    id: "221956663129",
    category: "NewsLetter",
    created: "2020.05.11",
    img: itemCard027,
    content: `TBELL NEWSLETTER Vol.14 - 2020.05.11 발행\n`
    +`01. 기획 - 코로나19 이후의 IT 기술경영 재해복구(Disaster Recovery)와`,
	},
  {
		title: "TBELL NEWSLETTER Vol.13",
    id: "221846602028",
    category: "NewsLetter",
    created: "2020.03.10",
    img: itemCard028,
    content: `TBELL NEWSLETTER Vol.13 - 2020.03.10 발행\n`
    +`01. 기획 - SW 테스트와 3.0 아웃소싱`,
	},
  {
		title: "TBELL NEWSLETTER Vol.11",
    id: "221700523742",
    category: "NewsLetter",
    created: "2019.11.07",
    img: itemCard029,
    content: `TBELL NEWSLETTER Vol.11 - 2019.11.07 발행\n`
    +`1. AI 기술을 활용한 소프트웨어 테스팅`,
	},
  {
		title: "TBELL NEWSLETTER Vol.10",
    id: "221653788720",
    category: "NewsLetter",
    created: "2019.09.20",
    img: itemCard030,
    content: `TBELL NEWSLETTER Vol.10 - 2019.09.20발행\n`
    +`1. AI 기반 응용 프로그램의 테스팅\n`
    +`2. 테스팅 관련 국내 주요 연구 소개`,
	},
  {
		title: "TBELL NEWSLETTER Vol.9",
    id: "221572143985",
    category: "NewsLetter",
    created: "2019.06.27",
    img: itemCard031,
    content: `TBELL NEWSLETTER Vol.9 - 2019.06.27발행\n`
    +`1. 일본 QA4AI의 AI제품 품질보증 가이드라인`,
	},
  {
		title: "TBELL NEWSLETTER Vol.8",
    id: "221551037494",
    category: "NewsLetter",
    created: "2019.05.31",
    img: itemCard032,
    content: `TBELL NEWSLETTER Vol.8 - 2019.04.28발행\n`
    +`1. JaSST'19 Tokyo 참가 Report`,
	},
  {
		title: "TBELL NEWSLETTER Vol.7",
    id: "221465658057",
    category: "NewsLetter",
    created: "2019.02.14",
    img: itemCard033,
    content: `TBELL NEWSLETTER Vol.7 - 2019.02.11발행\n`
    +`1. 2019년 소프트웨어 테스팅 트랜드`,
	},
  {
		title: "셀레늄(Selenium) 툴을 활용한 테스트 자동화 시연 (동영상)",
    id: "221016936138",
    sub: "2018~2019年 ",
    category: "티벨일상",
    created: "2017.05.29",
    img: itemCard034,
    content: `안녕하세요. 티벨지기 입니다. 오늘은 우리 티벨의 주 특기! 소프트웨어 테스트와 관련한 알찬 소식을 가지고 왔습니다. 바로 최근 소프트웨어 테스팅의`,
	},
  {
		title: "네비게이션 어플 5종 비교 후기, 사용성 테스트",
    id: "220943675909",
    sub: "2018~2019年 ",
    category: "티벨일상",
    created: "2017.02.24",
    img: itemCard035,
    content: `안녕하세요~! 티벨러입니다. 오늘은 운전 할 때 많이 사용하는 네비게이션 어플 5종을 비교 해보려고 해요.!! 각 어플의 장점과 단점을 간략히 확인 해보고`,
	},
  {
		title: "자율주행자동차 이해하기",
		id:"220929321606",
    sub: "2018~2019年 ",
    category: "티벨일상",
    created: "2017.02.07",
    img: itemCard036,
    content: `1. 자율주행차 자율주행은 자동차 스스로 주변 환경을 인지, 위험을 판단, 차량거동을 조작하여 운전자..`,
	}
];

export {
  HeaderMenuList,
  MainBannerList,
  CIList,
  ServiceFieldList,
  CommissionFieldList,
  DataBuildInstanceList,
  DomainList,
  InfoHistoryList,
  OfficeList,
  DataUsedExampleList,
  AutoLabelingContentList,
  CardNewsList,
}